import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.tag || initialState;

export const selectTag = createSelector([selectSlice], state => state);
